import React, { useEffect } from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { Button, Col, Form, Input, Layout, message, Modal, Pagination, Row, Space, Table, Tooltip } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import UploadFile from "../common/upload-file";
import { useStore } from "../../store";
import { ColumnsType } from "antd/lib/table";
import { ImageInfoEntity } from "../../entity/image-info-entity";
import { delImageInfo, getImageInfo } from "../../http/manager";
import { transaction } from "mobx";
import Picture from "./picture";
import PictureDetail from "./picture-detail";
import "../../css/table-scroll-y.css"


const PictureList: React.FC = () => {

    const { PictureStore } = useStore();

    useEffect(() => {
        queryPictureList();
        return PictureStore.clear
    }, []);

    const columns: ColumnsType<ImageInfoEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align: "center",
            render: (value, record, index) => {
                return <div>{index + 1}</div>
            }
        },
        {
            title: '中文名',
            width: 200,
            dataIndex: 'cnName',
            key: 'cnName',
            align: "center"
        },
        {
            title: '拉丁名',
            width: 300,
            dataIndex: 'ldName',
            key: 'ldName',
            align: "center",
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '属中文名',
            width: 150,
            dataIndex: 'genCnName',
            key: 'genCnName',
            align: "center"
        },
        {
            title: '属拉丁名',
            width: 150,
            dataIndex: 'genLdName',
            key: 'genLdName',
            align: "center"
        },
        {
            title: '科中文名',
            width: 150,
            dataIndex: 'specCnName',
            key: 'specCnName',
            align: "center"
        },
        {
            title: '科拉丁名',
            width: 150,
            dataIndex: 'specLdName',
            key: 'specLdName',
            align: "center"
        },
        {
            title: '图片编号',
            width: 150,
            dataIndex: 'imageCode',
            key: 'imageCode',
            align: "center"
        },
        {
            title: '操作',
            width: 300,
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            align: "center",
            render: (value, record) => {
                return <Space size="middle">
                    <Button onClick={() => toEditModal(record)} type={"primary"}>编辑</Button>
                    <Button onClick={() => toDetailModal(record)} type={"primary"}>详情</Button>
                    <Button onClick={() => openDeleteConfirm(record)} type={"primary"} danger={true}>删除</Button>
                </Space>
            }
        },
    ];

    const openDeleteConfirm = (record: ImageInfoEntity) => {
        PictureStore.showDeleteConfirm(true);
        PictureStore.setDeleteRecord(record);
    }

    const deleteButton = () => {
        const params = {
            id: PictureStore.deleteRecord.id,
        }
        deleteBaseLibrary(params);
    }

    const deleteBaseLibrary = (params: any) => {
        delImageInfo(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("删除成功");
                    onDeleteConfirmClose();
                    queryPictureList(false);
                } else {
                    if (res.message) {
                        message.error(res.message);
                    } else {
                        message.error("删除失败");
                    }
                }
            }).catch(() => {
            message.error("删除失败");
        })
    }

    const toEditModal = (record: ImageInfoEntity) => {
        PictureStore.setDetailType("edit");
        PictureStore.setBaseLibraryDetail(record);
        PictureStore.setShowEdit(true)
    }

    const toDetailModal = (record: ImageInfoEntity) => {
        PictureStore.setBaseLibraryDetail(record);
        PictureStore.setShowDetail(true)
    }

    const openUploadFileModal = () => {
        PictureStore.setShowUpload(true);
    }

    const setNameCn = (e: any) => {
        PictureStore.condition.pictureCnName = e.target.value;
    }

    const setLdName = (e: any) => {
        PictureStore.condition.pictureLdName = e.target.value;
    }

    const setGenCnName = (e: any) => {
        PictureStore.condition.pictureGenCnName = e.target.value;
    }

    const setGenLdName = (e: any) => {
        PictureStore.condition.pictureGenLdName = e.target.value;
    }

    const setSpecCnName = (e: any) => {
        PictureStore.condition.pictureSpecCnName = e.target.value;
    }

    const setSpecLdName = (e: any) => {
        PictureStore.condition.pictureSpecLdName = e.target.value;
    }

    const onQuery = () => {
        queryPictureList();
    }

    const onResetOnclick = () => {
        PictureStore.resetQueryCondition();
        queryPictureList();
    }

    const OnDetailModalClose = () => {
        PictureStore.setShowDetail(false);
    }

    const OnEditModalClose = () => {
        PictureStore.setShowEdit(false);
        queryPictureList(false);
    }

    const onEditSuccess = () => {
        OnEditModalClose();
    }

    const openAddPictureModal = () => {
        PictureStore.clearDetail()
        PictureStore.setDetailType("add");
        PictureStore.setShowEdit(true);
    }

    const queryPictureList = (isClear: boolean = true) => {
        const params = {
            cnName: PictureStore.condition.pictureCnName,
            ldName: PictureStore.condition.pictureLdName,
            genCnName: PictureStore.condition.pictureGenCnName,
            genLdName: PictureStore.condition.pictureGenLdName,
            specCnName: PictureStore.condition.pictureSpecCnName,
            specLdName: PictureStore.condition.pictureSpecLdName,
            pageNum: PictureStore.pagination.pageNum,
            pageSize: PictureStore.pagination.pageSize,
        }
        getImageInfo(params)
            .then((res) => {
                refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
                PictureStore.pagination.total = res.data ? res.data.total : 0
            })
    }

    const refreshTableData = (data: ImageInfoEntity[]) => {
        const list: ImageInfoEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            PictureStore.setDataSource(list);
        })
    }

    const onUploadClose = () => {
        PictureStore.setShowUpload(false);
    }

    const onUploadSuccess = () => {
        onUploadClose();
        onQuery();
    }

    const onDeleteConfirmClose = () => {
        PictureStore.showDeleteConfirm(false);
    }

    const onSizeChange = (page: any, pageSize: any) => {
        PictureStore.pagination.pageSize = pageSize;
        PictureStore.pagination.pageNum = page;
        onQuery();
    }

    return (
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding: "0"}}>
                <TitleSpan>原植物图库</TitleSpan>
            </Header>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    <SearchWrapper>
                        <Space>
                            <Button onClick={openUploadFileModal} type={"primary"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}} size={"large"}>批量上传</Button>
                            <Button onClick={openAddPictureModal} type={"default"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}} size={"large"}>新建</Button>
                        </Space>
                        <Form labelAlign={"right"} wrapperCol={{span: "15"}}>
                            <Row justify={"space-between"} gutter={[15, 0]}>
                                <Col span={8}>
                                    <Form.Item labelCol={{span:"7"}} label={"中文名"}><Input onChange={setNameCn}
                                                                     value={PictureStore.condition.specimenName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item labelCol={{span:"7"}} label={"拉丁名"}><Input onChange={setLdName}
                                                                     value={PictureStore.condition.specimenCanonicalName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item labelCol={{span:"7"}} label={"属中文名"}><Input onChange={setGenCnName}
                                                                     value={PictureStore.condition.pictureGenCnName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item labelCol={{span:"7"}} label={"属拉丁名"}><Input onChange={setGenLdName}
                                                                     value={PictureStore.condition.pictureGenLdName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item labelCol={{span:"7"}} label={"科中文名"}><Input onChange={setSpecCnName}
                                                                     value={PictureStore.condition.pictureSpecCnName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item labelCol={{span:"7"}} label={"科拉丁名"}><Input onChange={setSpecLdName}
                                                                     value={PictureStore.condition.pictureSpecLdName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={8} push={8}>
                                    <SpaceButton>
                                        <Button onClick={ onQuery } type={"primary"}>查询</Button>
                                        <Button onClick={ onResetOnclick } type={"default"}>重置</Button>
                                    </SpaceButton>
                                </Col>
                            </Row>
                        </Form>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Table
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            style={{margin: "15px 15px 0 15px"}}
                            size={"small"}
                            bordered={true}
                            // rowSelection={{fixed:"left", type:"checkbox"}}
                            dataSource={PictureStore.dataSource}
                            columns={columns}
                            pagination={{position: [], pageSize: PictureStore.pagination.pageSize}}
                        />
                        <Pagination
                            size={"small"}
                            style={{margin: "15px 15px 15px 0", alignSelf: "end"}}
                            total={PictureStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            hideOnSinglePage={true}
                            onChange={onSizeChange}
                            current={PictureStore.pagination.pageNum}
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal onCancel={OnDetailModalClose}
                       width={"750px"}
                       open={PictureStore.isShowDetail}
                       closable={true}
                       centered={true}
                       footer={null}
                       mask={true}
                       title={"原植物图库详情"}
                       destroyOnClose={true}
                       maskClosable={true}>
                    <PictureDetail/>
                </Modal>
                <Modal onCancel={OnEditModalClose}
                       width={"750px"}
                       open={PictureStore.isShowEdit}
                       closable={true}
                       centered={true}
                       footer={null}
                       mask={true}
                       destroyOnClose={true}
                       title={PictureStore.detailType === "add" ? "新建原植物图库" : "编辑原植物图库"}
                       maskClosable={true}>
                    <Picture onSuccess={onEditSuccess}/>
                </Modal>
                <Modal onCancel={onUploadClose}
                       width={"500px"}
                       open={PictureStore.isShowUpload}
                       closable={true}
                       centered={true}
                       footer={null}
                       destroyOnClose={true}
                       mask={true}
                       title={"批量上传"}
                       maskClosable={true}>
                    <UploadFile onSuccess={onUploadSuccess} funType={3}/>
                </Modal>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={PictureStore.isShowDeleteCOnfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
            </Content>
        </Layout>
    );
}
export default observer(PictureList);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-table-body {
      overflow-x: scroll !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .ant-picker{
      width: 100%;
    }
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;
const SpaceButton = styled.div`
& {
  display: flex;
  justify-content: center;
  .ant-btn {
    margin: 0 12px;
  }
}
`;

